module.exports = __webpack_public_path__ + "static/media/transport.76bd1c91.png";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/transport.png
// module id = 1794
// module chunks = 1